class Image
{
    private readonly container: HTMLDivElement;
    private readonly image: HTMLImageElement;
    private readonly mobileContainer: HTMLDivElement;
    private readonly percentage: number;

    constructor(container: HTMLDivElement, resolve: (value: Image) => void)
    {
        this.container = container;
        this.percentage = parseInt(this.container.getAttribute('data-mobile'))

        this.image = <HTMLImageElement>this.container.querySelector('img');

        this.mobileContainer = document.createElement('div');
        this.mobileContainer.classList.add('sep-image-mobile');
        this.mobileContainer.style.display = 'none';
        this.container.parentNode.insertBefore(this.mobileContainer, this.container);

        if (this.image.complete) {
            this.asyncUpdateSizes(resolve);
        } else {
            this.image.addEventListener('load', () => {
                this.asyncUpdateSizes(resolve);
            })
        }
    }

    public update() {
        // @ts-ignore
        return new Promise(resolve => {
            this.asyncUpdateSizes(resolve)
        })
    }

    private asyncUpdateSizes(resolve: (value: Image) => void) {
        const factor = this.image.width / window.innerWidth
        const fullHeight = this.image.height * factor;
        const percentageHeight = (fullHeight * 100 / this.percentage);

        const styles = {
            backgroundImage: `url(${this.image.getAttribute('src')})`,
            width: '100%',
            height: percentageHeight + 'px',
            backgroundSize: 'cover',
            backgroundPosition: 'center center'
        }

        for (let key in styles) {
            this.mobileContainer.style[key] = styles[key]
        }

        if (window.innerWidth < 830) {
            this.container.style.visibility = 'hidden';
            this.container.style.minHeight = '0';
            this.container.style.maxHeight = '0';
            this.mobileContainer.style.display = 'block';
        } else {
            this.container.style.visibility = 'visible';
            this.container.style.minHeight = '40px';
            this.container.style.maxHeight = 'inherit';
            this.mobileContainer.style.display = 'none';
        }

        resolve(this);
    }

    public static load(container: HTMLDivElement)
    {
        // @ts-ignore
        return new Promise(resolve => {
            new Image(container, resolve)
        });
    }
}

class Handler
{
    private images: Array<Image> = [];
    private callback: Function;

    constructor(callback: Function) {
        this.callback = callback;

        const containers = document.querySelectorAll('.sep-image');

        const promises = [];

        // @ts-ignore
        for (let container of containers) {
            if (container.getAttribute('data-mobile')) {
                promises.push(Image.load(container))
            }
        }

        // @ts-ignore
        Promise.all(promises)
            .then((images) => {
                callback(images)

                this.images = images
            })

        window.addEventListener('resize', () => {
            this.onResize()
        })
    }

    private onResize() {
        const promises = [];

        for (let image of this.images) {
            promises.push(image.update())
        }

        // @ts-ignore
        Promise.all(promises)
            .then(this.callback)
    }
}

export default function initSeparatorImages (callback) {
    new Handler(callback)
}
